import { render, staticRenderFns } from "./EstageInternalEmbedMod.vue?vue&type=template&id=463204e5"
import script from "./EstageInternalEmbedMod.vue?vue&type=script&lang=js"
export * from "./EstageInternalEmbedMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports